<template>
  <div class="relative container">
    <div class="title-lg mg-bt-md">
      <span>操作帮助</span>
    </div>
    <div style="padding: 10px" class="fl-wrap">
      <DataCard download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_fz/doc/%E7%A6%8F%E5%B7%9E%E5%9F%8E%E5%B8%82%E5%AE%89%E5%85%A8%E9%A3%8E%E9%99%A9%E7%AE%A1%E6%8E%A7%E4%BF%A1%E6%81%AF%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E%EF%BC%88%E7%9B%91%E7%AE%A1%E7%AB%AF%EF%BC%89.pdf" style="width: 250px; margin-right: 25px" title="福州城市安全风险管控信息平台操作手册"></DataCard>
      <DataCard type="video" download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_fz/video/1.%E4%BC%81%E4%B8%9A%E8%B4%A6%E5%8F%B7%E6%B3%A8%E5%86%8C%E5%A1%AB%E6%8A%A5%E8%AE%B2%E8%A7%A3.mp4" style="width: 250px; margin-right: 25px" title="企业账号注册填报讲解"></DataCard>
      <DataCard type="video" download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_fz/video/2.%E5%9F%BA%E7%A1%80%E4%BF%A1%E6%81%AF%E5%A1%AB%E6%8A%A5%E8%AE%B2%E8%A7%A3.mp4" style="width: 250px; margin-right: 25px" title="基础信息填报讲解"></DataCard>
      <DataCard type="video" download="https://risk-city.oss-cn-hangzhou.aliyuncs.com/risk_fz/video/3.%E9%A3%8E%E9%99%A9%E5%8D%95%E5%85%83%E5%A1%AB%E6%8A%A5%E8%AE%B2%E8%A7%A3.mp4" style="width: 250px; margin-right: 25px" title="风险单元填报讲解"></DataCard>
    </div>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" class="input_video">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions">
      </video-player>
    </el-dialog>
  </div>
</template>

<script>
import DataCard from '@/Util/DataCard'
export default {
  components: {
    DataCard
  },
  data() {
    return {
      title: '',
      visible: false,
      playerOptions: {
        language: 'zh-CN',
        playbackRates: [ 0.5, 1.0, 1.5, 2.0 ], // 可选择的播放速度
        aspectRatio: '16:9',
        fluid: true,
        sources: [{
          type: '',
          src: '' // url地址
        }]
      }
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    showVideo (src, title) {
      this.visible = true
      // this.playerOptions.sources[0].src = src
      // this.title = title
      this.$nextTick(() => {
        this.$refs.videoPlayer.player.src(src)
        this.$refs.videoPlayer.player.reset()
        this.title = title
      })
    }
  }
}
</script>

<style scoped>
  .close {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 32px;
    cursor: pointer;
    color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/views/systemData/systemData.vue